import type { ReactNode } from "react";

interface ParticipantPreviewContentScreenProps {
  eyebrow: string;
  title: string;
  description: string;
  terms?: string | null;
  actions?: ReactNode;
  centered?: boolean;
  className?: string;
}

export function ParticipantPreviewContentScreen({
  eyebrow,
  title,
  description,
  terms,
  actions,
  centered = false,
  className,
}: ParticipantPreviewContentScreenProps) {
  return (
    <div className={`flex min-h-full items-start justify-center px-6 py-8 ${className ?? ""}`}>
      <div
        className={`w-full max-w-2xl rounded-[28px] border border-[#D9B64B]/18 bg-[linear-gradient(180deg,rgba(13,13,13,0.98),rgba(5,5,5,0.98))] p-8 shadow-[0_28px_90px_rgba(0,0,0,0.45)] ${
          centered ? "text-center" : ""
        }`}
      >
        <p className="text-xs font-semibold uppercase tracking-[0.28em] text-[#D9B64B]">
          {eyebrow}
        </p>
        <h1 className="mt-3 text-3xl font-semibold text-white">{title}</h1>
        <p className="mt-4 whitespace-pre-wrap text-base leading-7 text-slate-300">
          {description}
        </p>

        {terms && terms.trim() && (
          <div className="mt-6 rounded-2xl border border-white/10 bg-black/35 p-4">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#D9B64B]/75">
              Terms
            </p>
            <p className="mt-3 whitespace-pre-wrap text-sm leading-6 text-slate-400">
              {terms}
            </p>
          </div>
        )}

        {actions ? (
          <div
            className={`mt-8 flex items-center ${
              centered ? "justify-center" : "justify-end"
            }`}
          >
            {actions}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default ParticipantPreviewContentScreen;
